import React from 'react';

import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';
import { shopPods, checkout } from 'apps/cart/paths';

interface Props {
  lineItemsProcessing: LineItem[];
  itemQuantity: number;
  hasViolations: boolean;
  handleClick(): void;
  numOfSubscribableItemsReqToCheckout: number;
  maximumAllowedPods: number;
  totalPodsHaveExceededMaximum?: boolean;
  continueButtonTranslationId?: string;
}

export class CheckoutButton extends React.Component<Props> {
  setWindowLocation = () => {
    const { numOfSubscribableItemsReqToCheckout } = this.props;
    const url =
      numOfSubscribableItemsReqToCheckout > 0 ? shopPods() : checkout();
    window.location.assign(url);
  };

  get buttonText() {
    const remainingPods = this.props.numOfSubscribableItemsReqToCheckout;
    const {
      totalPodsHaveExceededMaximum,
      maximumAllowedPods,
      continueButtonTranslationId,
    } = this.props;

    if (remainingPods > 0) {
      return (
        <TranslatedMessage
          id={'cart.checkout_button.add_remaining'}
          values={{ count: remainingPods }}
        />
      );
    }

    if (totalPodsHaveExceededMaximum) {
      return (
        <TranslatedMessage
          id={'cart.checkout_button.remove_excess'}
          values={{ num: maximumAllowedPods }}
        />
      );
    }
    return (
      <TranslatedMessage
        id={continueButtonTranslationId || 'cart.checkout_button.proceed'}
      />
    );
  }

  render() {
    const { itemQuantity, lineItemsProcessing, hasViolations } = this.props;

    const isEmpty = itemQuantity === 0;
    const isProcessing = lineItemsProcessing.length > 0;
    const checkoutDisabled = isEmpty || isProcessing || hasViolations;

    const buttonProps = {
      processing: isProcessing,
      disabled: checkoutDisabled,
      className: 'cart-ledger__checkout button--full-width',
      onClick: this.props.handleClick || this.setWindowLocation,
    };
    return <Button {...buttonProps}>{this.buttonText}</Button>;
  }
}
